// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import moment from 'moment';
import { Grid, Row, Col, Button } from 'react-bootstrap/lib';
import styler from 'react-styling';

import { Scheduler, CreateEventModal, Event } from '../index';
import { filterNotNullEdgeNodes } from '../../libs/Extract';
import { setLocalStorageItem } from '../../libs/LocalStorage';

const style = styler `
  ClosingBtn
    z-index: 100
`;

class SchedulerComponent extends Component {
  componentWillUnmount() {
    const emailsArr = [];
    const { emails } = this.props.relay.variables;
    // guard against this.props.relay.variables.emails is not an array
    if (Array.isArray(emails)) {
      emails.forEach((email, index) => {
        emailsArr[index] = email;
      });
      setLocalStorageItem('scheduler', emailsArr);
    }
  }

  props: {
    viewer: Object,
    relay: Object,
    emails: Array<string>,
    startDate: Date,
    endDate: Date,
    languagedata: Object,
    loading: boolean,
    forceFetch: Function,
    setDateRange: Function,
    changeSelectedTo: Function,
    schedulerComponent: Object,
    showContactInfoMobile: boolean,
    toggleContactInfoMobile: Function,
  }

  render() {
    const { contact, contacts, meetingRooms, otherResources } = this.props.viewer;
    const contactsFiltered = filterNotNullEdgeNodes(contacts);
    const meetingRoomsFiltered = filterNotNullEdgeNodes(meetingRooms);
    const otherResourcesFiltered = filterNotNullEdgeNodes(otherResources);
    const initialContactsSelected = [...contactsFiltered, ...meetingRoomsFiltered, ...otherResourcesFiltered];
    return (
      <Grid fluid>
        <Row>
          <Col md={8} className={`user-info ${(this.props.showContactInfoMobile ? ' show-user-info' : '')}`}>
            <Button
              onClick={() => this.props.toggleContactInfoMobile()}
              bsSize="small"
              className="hide-user-info hidden-md hidden-lg"
              style={style.ClosingBtn}
            >
              <i className="fa fa-close text-muted" />
            </Button>
            <Scheduler
              viewer={this.props.viewer}
              contact={contact}
              contactsSelected={initialContactsSelected}
              startDate={moment.unix(this.props.relay.variables.startDate)}
              endDate={moment.unix(this.props.relay.variables.endDate)}
              languagedata={this.props.languagedata}
              forceFetch={this.props.forceFetch}
              setDateRange={this.props.setDateRange}
              changeSelectedTo={this.props.changeSelectedTo}
              emails={this.props.relay.variables.emails}
              start={this.props.relay.variables.startDate}
              end={this.props.relay.variables.endDate}
              relay={this.props.relay}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}


export default Relay.createContainer(SchedulerComponent, {
  initialVariables: {
    selectedContactEmail: null,
    emails: [null],
    startDate: null,
    endDate: null,
  },
  fragments: {
    viewer: (vars) => Relay.QL`
      fragment on Viewer {
        contact(email: $selectedContactEmail) {
          id
          displayName
          title
          department
          email
          city
        }
        contacts(first: 100000, emails: $emails) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        meetingRooms(first: 10000, emails: $emails) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        otherResources(first: 10000, emails: $emails) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        ${CreateEventModal.getFragment('viewer')},
        ${Event.getFragment('event', vars)},
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/Scheduler/SchedulerComponent.js